import store from "../store/store";
import {history} from "../components/router/CustomBrowserRouter";

export function logout() {
    history.replace("/logout");
}

export const getUserApiData = ({FarmID, ClientID, LocalUserID} = {}) => {
    const state = store.getState();
    const {
        user: {
            user: {LocalUserID: _luid, ClientID: _cid},
        },
        location: {farm: _fid},
    } = state;
    return {
        _FarmID: FarmID || _fid,
        _LocalUserID: LocalUserID || _luid,
        _ClientID: ClientID || _cid,
    };
};

export const getAttributesFromCognitoUser = (cognitoUser, sub) => {
    const {
        username,
        attributes: {
            name,
            email,
            phone_number,
            address,
            locale,
            family_name,
            email_verified,
            phone_number_verified,
        },
    } = cognitoUser;
    return {
        login: username,
        name,
        email,
        phone: phone_number,
        address,
        locale,
        surname: family_name,
        emailVerified: email_verified,
        phoneVerified: phone_number_verified,
        sub,
    };
};

export const UserTypeUtils = {
    // user type negation utils
    isNegation: (str) => /![A-Z]+/.test(str),
    NOT: (userType) => `!${userType}`,
    removeNegation: (userTypeStr) => {
        if (userTypeStr.startsWith("!")) {
            return userTypeStr.substr(1);
        }
        return userTypeStr;
    },
};

export const sortCheckedUsers = (
    array,
    checked,
    currentLocalUserID,
    specificProject
) => {
    const valueSet = new Set(checked);

    return array.sort((a, b) => {
        const aVal = specificProject ? a.user.LocalUserID : a.LocalUserID;
        const bVal = specificProject ? b.user.LocalUserID : b.LocalUserID;

        const aInSet = valueSet.has(aVal);
        const bInSet = valueSet.has(bVal);

        if (aInSet && !bInSet) return -1;
        if (!aInSet && bInSet) return 1;

        const aIsMe = specificProject
            ? a.user.LocalUserID === currentLocalUserID
            : a.LocalUserID === currentLocalUserID;
        const bIsMe = specificProject
            ? b.user.LocalUserID === currentLocalUserID
            : b.LocalUserID === currentLocalUserID;

        if (aIsMe && !bIsMe) return -1;
        if (!aIsMe && bIsMe) return 1;

        return 0;
    });
};
